import { Vehicle } from '../@types/Vehicle';
import { sendRequest } from './http';

const getValuation = async (url: string, registrationNumber: string) => {
  const params = new URLSearchParams();
  params.set('regNo', registrationNumber);

  return await sendRequest<Vehicle>({
    method: 'GET',
    url: `${url}/wip/external/vehicleenrichment?${params.toString()}`,
  });
};

export const getVehicleErrorMessage = (status?: number) => {
  switch (status) {
    case 404:
      return 'Ajdå, vi verkar inte kunna hämta in någon data på den här bilen och kan inte ge dig någon värdering, det kan exempelvis bero på att bilen är importerad. Dubbelkolla också gärna att du skrivit in rätt registreringsnummer.';
    default:
      return 'Ett fel har inträffat, försök igen.';
  }
};

export default getValuation;
